function whatsappWidget() {
    return {
        isOpen: false,
        showBadge: true,
        chatLink: window.chat_link, // passed from Liquid

        init() {
        this.$watch('isOpen', (value) => {
            if (value && this.showBadge) {
            setTimeout(() => {
                this.showBadge = false;
            }, 1000);
            }
        });

        const hasInteracted = localStorage.getItem('whatsapp-widget-interacted');
        if (hasInteracted) this.showBadge = false;
        },

        togglePopup() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) this.markAsInteracted();
        },

        closePopup() {
        this.isOpen = false;
        },

        markAsInteracted() {
        try {
            localStorage.setItem('whatsapp-widget-interacted', 'true');
            this.showBadge = false;
        } catch (e) {}
        },

        getPhoneFromLink(link) {
        const match = link.match(/phone=([0-9]+)/);
        return match ? match[1] : null;
        },

        getChatLink() {
        const isMobile = /Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
        const phone = this.getPhoneFromLink(this.chatLink);
        if (!phone) return this.chatLink; // fallback
        return isMobile
            ? `https://wa.me/${phone}`
            : this.chatLink;
        },

        handleChatClick() {
        this.markAsInteracted();
        this.closePopup();

        if (typeof gtag !== 'undefined') {
            gtag('event', 'whatsapp_chat_click', {
            event_category: 'engagement',
            event_label: 'whatsapp_widget'
            });
        }

        window.open(this.getChatLink(), '_blank');
        }
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('whatsappWidget', whatsappWidget);
});